(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/utils/assets/javascripts/oms-key.js') >= 0) return;  svs.modules.push('/components/accountservices/utils/assets/javascripts/oms-key.js');

'use strict';

var _svs, _svs2;
svs = svs || {};
svs.accountservices = svs.accountservices || {};
svs.accountservices.utils = svs.accountservices.utils || {};
let log;
if ((_svs = svs) !== null && _svs !== void 0 && (_svs = _svs.core) !== null && _svs !== void 0 && _svs.log) {
  log = new svs.core.log.Logger('components:accountservices:utils:omskey');
}
const isPnp = ((_svs2 = svs) === null || _svs2 === void 0 || (_svs2 = _svs2.core) === null || _svs2 === void 0 || (_svs2 = _svs2.config) === null || _svs2 === void 0 || (_svs2 = _svs2.data) === null || _svs2 === void 0 || (_svs2 = _svs2.svsconfig) === null || _svs2 === void 0 || (_svs2 = _svs2.site) === null || _svs2 === void 0 ? void 0 : _svs2.toLowerCase()) === 'momang';
const omsKeys = {
  'ios-hybrid-mobile': 36,
  'android-hybrid-mobile': 36,
  'ios-hybrid-tablet': 37,
  'web-mobile': isPnp ? 49 : 31,
  'web-tablet': isPnp ? 50 : 34,
  'web-desktop': isPnp ? 48 : 10,
  'poker-desktop': 46,
  'poker-mobile': 44
};
class OmsKey {
  static getClientSide() {
    try {
      return omsKeys[svs.core.data.capabilities.channel];
    } catch (e) {
      log && log.error('Error getting OMS key for channel', e);
      return null;
    }
  }
}
svs.accountservices.utils.OmsKey = OmsKey;

 })(window);